import { render } from "./MainPos2.vue?vue&type=template&id=e22b50d6"
import script from "./MainPos2.vue?vue&type=script&lang=js"
export * from "./MainPos2.vue?vue&type=script&lang=js"

import "./MainPos2.vue?vue&type=style&index=0&id=e22b50d6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__